import { MACHINE_SERVICE_TYPES } from '../../constants';

export const shouldConfirmStockLevels = ({
	machineUsesIngredients,
	isOffline,
}) => !machineUsesIngredients && !isOffline;

// Older clients do not load expiry signals; keep their existing steps until the server completes the visit.
// Repair visits with loaded signals only need confirmation when expiry checks need attention.
export const isStockConfirmationRequired = docket => (
	docket?.machineServiceType !== MACHINE_SERVICE_TYPES.REPAIR ||
	(docket?.hasSomeExpiryDatesToUpdate === undefined && docket?.productExpiryCheckSchedules === undefined) ||
	Boolean(docket?.hasSomeExpiryDatesToUpdate || docket?.productExpiryCheckSchedules?.length)
);
